import { PaymentMethod } from "core/types/PaymentMethod";
import { TagManagerObject } from "core/types/TagManagerObject";

/**
 * core/types/TagManagerObject
 * ----------------------------------------------------------------------
 * @since     0.0.1
 */
export class SubscriberCreateRequest extends TagManagerObject {
  /**
   * @type {string}
   */
  email = null;
  
  /**
   * @type {string}
   */
  phone = null;
  
  /**
   * @type {string}
   */
  password = null;
  
  /**
   * @type {string}
   */
  passwordConfirmation = null;
  
  /**
   * @type {string}
   */
  firstName = null;
  
  /**
   * @type {string}
   */
  lastName = null;

  /**
   * @type {string|number}
   */
  birthday = null;
  
  /**
   * @type {string}
   */
  encryptedInviterId = null;
  
  /**
   * @type {string}
   */
  captcha = null;
  
  /**
   * @type {string}
   */
  cpf = null;
  
  /**
   * @type {string}
   */
  couponName = null;

  /**
   * @type {number}
   */
  subscriptionTypeId = null;
  
  /**
   * @type {string}
   */
  city = null;
  
  /**
   * @type {string}
   */
  state = null;
  
  /**
   * @type {number}
   */
  compositionId = null;
  
  /**
   * @type {number}
   */
  subscriptionId = null;
  
  /**
   * @type {number}
   */
  editionId = null;
  
  /**
   * @type {string}
   */
  startEditionName = null;
  
  /**
   * @type {number}
   */
  shippingPrice = null;

  /**
   * @type {boolean}
   */
  wants_to_be_in_mailing_list = null;

  // SHIPPING
  // --------------------------------------------------------------------

  /**
   * @type {string}
   */
  shippingName = null;

  /**
   * @type {string|number}
   */
  shippingPostalCode = null;

  /**
   * @type {string|number}
   */
  shippingPhone = null;

  /**
   * @type {string}
   */
  shippingStreet = null;

  /**
   * @type {string}
   */
  shippingStreetExtension = null;

  /**
   * @type {string}
   */
  shippingStreetNeighborhood = null;

  /**
   * @type {string|number}
   */
  shippingStreetNumber = null;

  /**
   * @type {number}
   */
  shippingStateCityId = null;

  /**
   * @type {number}
   */
  shippingCityId = null;

  // BILLING
  // --------------------------------------------------------------------

  /**
   * @type {string|number}
   */
  billingPostalCode = null;

  /**
   * @type {string|number}
   */
  billingPhone = null;

  /**
   * @type {string}
   */
  billingStreet = null;

  /**
   * @type {string}
   */
  billingStreetExtension = null;

  /**
   * @type {string}
   */
  billingStreetNeighborhood = null;

  /**
   * @type {string|number}
   */
  billingStreetNumber = null;

  /**
   * @type {number}
   */
  billingCityId = null;

  /**
   * @type {number}
   */
  billingStateId = null;

  // PAYMENT
  // --------------------------------------------------------------------

  /**
   * @type {PaymentMethod[]}
   */
  listPaymentMethod = [];

  // --------------------------------------------------------------------

  /**
   * ?
   */
  constructor () {
    super();
  }
}
